import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { loaderSelector } from '../../store/loader/selectors';
import styles from './Loader.module.scss';

const Loader = () => {
  const isLoading = useSelector(loaderSelector());

  return (
    <div>
      {isLoading && (
        <div className={styles.container}>
          <CircularProgress />
        </div>
      )}
    </div>
  );
};

export default Loader;
